import React, { useCallback, useState } from 'react';
import { Card, CardHeader, Collapse, CardBody, Button } from 'reactstrap';

export default function Accordion(props) {
  const { content } = props;

  const sizing = content.length;
  const initialState = [];
  for (let i = 0; i < sizing; i++) {
    initialState.push((i === 0) ? true : false);
  }

  const [accordion, setAccordion] = useState(initialState);
  const toggleAccordion = useCallback((position) => {
    let currentAccordion = accordion;
    currentAccordion = currentAccordion.map((value, index) => {
      return position === index;
    });
    setAccordion(currentAccordion);
  }, [accordion, setAccordion]);

  return (
    <div id="accordion" className="accordion-wrapper mb-3">
      {content && content.length > 0 && content.map((value, index) => (
        <Card key={index}>
          <CardHeader id={`heading${index}`}>
            <Button block color="link" className="text-left m-0 p-0"
              onClick={() => toggleAccordion(index)}
              aria-expanded={accordion[index]}
              aria-controls={`collapse${index}`}>
              <h5 className="m-0 p-0">{value.title}</h5>
            </Button>
          </CardHeader>
          <Collapse isOpen={accordion[index]} data-parent="#accordion"
            id={`collapse${index}`} aria-labelledby={`heading${index}`}>
            <CardBody>
              {value.content}
            </CardBody>
          </Collapse>
        </Card>
      ))}
    </div>
  );
}
